module.exports = __webpack_public_path__ + "node_modules/icheck/skins/minimal/minimal.png?5374dd98";